import axiosInstance from "../../../api/axiosInstance";

let deleteUser = async(user) => {
    return new Promise((resolve, reject) => {   
        axiosInstance.delete(process.env.REACT_APP_API + "/users/delete/" + user).then(response=> {
            resolve(response);
        }).catch(error => {
            resolve(error.response);
        });
    })
}
export default deleteUser